module.exports = __webpack_public_path__ + "img/shift-option.5c2f2ee5.webp";